<template>
  <div>
    <app-button
      type="outlined"
      variant="neutral"
      class="my-1 btn-allow-wrap"
      size="small"
      @click="openDialog = true"
    >
      <app-material-icon
        name="block"
        color="icon-danger"
      />
      {{ $t('project.signing-checklist.list.SigningChecklistTableItemInvalidateDialog.validation.invalidateDocument') }}
    </app-button>
    <AppDialog :is-open="openDialog"
               :ok-disabled="deleteValidationPending"
               :ok-loading="deleteValidationPending"
               :cancel-disabled="deleteValidationPending"
               @cancel="openDialog = false"
               @ok="prepareDeleteValidation"
    >
      <template #title>{{ $t('project.signing-checklist.list.SigningChecklistTableItemInvalidateDialog.dialog.title') }}</template>
      <template #body>
        {{ $t('project.signing-checklist.list.SigningChecklistTableItemInvalidateDialog.dialog.text') }}
      </template>
    </AppDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import AppDialog from '@/common/dialogs/AppDialog.vue'
import { toast } from '@/common/utils/toast'
import { DELETE_VALIDATION, REFRESH_STEP } from '@/store/modules/signing-checklist/action_types'

export default {
  name: 'SigningChecklistTableItemInvalidateDialog',
  components: { AppDialog },
  props: {
    mnemo: {
      type: String,
      required: true,
    },
    envelopeId: {
      type: Number,
      required: true,
    },
    validationId: {
      type: Number,
      required: true,
    },
    stepId: {
      type: Number,
      required: true,
    },
    parent: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      openDialog: false,
    }
  },
  computed: {
    ...mapState('signingChecklist', ['deleteValidationPending']),
  },
  methods: {
    ...mapActions('signingChecklist', [DELETE_VALIDATION, REFRESH_STEP]),
    async prepareDeleteValidation () {
      try {
        await this.DELETE_VALIDATION({
          mnemo: this.mnemo,
          envelopeId: this.envelopeId,
          validationId: this.validationId,
        })
        this.openDialog = false
        toast.success(this.$t('project.signing-checklist.list.SigningChecklistTableItemInvalidateDialog.message.success'))
        await this.REFRESH_STEP({
          mnemo: this.mnemo,
          stepId: this.stepId,
          parent: this.parent,
        })
      } catch (e) {
        console.error(e)
        toast.error(this.$t('project.signing-checklist.list.SigningChecklistTableItemInvalidateDialog.message.error'))
      }
    },
  },
}
</script>
